import { NavLink, Outlet } from "react-router";
import { useCampaignDetail } from "./context";
import type { SectionSlot } from "./sections";

interface Props {
  slots: SectionSlot[];
  // Accessible label for the sub-nav, e.g. "DEFINE sections".
  ariaLabel: string;
}

// Sub-nav shell for a top-level campaign section (DEFINE / RUN). Renders the
// slot links and an Outlet, forwarding the campaign detail context so the
// migrated editors that later land in these slots receive it unchanged.
export function SectionNav({ slots, ariaLabel }: Props) {
  const context = useCampaignDetail();

  return (
    <div>
      <nav className="flex flex-wrap gap-1 border-b border-border" aria-label={ariaLabel}>
        {slots.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `-mb-px border-b-2 px-3 py-1.5 text-sm font-medium transition-colors ${
                isActive
                  ? "border-accent text-accent"
                  : "border-transparent text-text-muted hover:border-border-strong hover:text-text-secondary"
              }`
            }
            end={false}
          >
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="mt-4">
        <Outlet context={context} />
      </div>
    </div>
  );
}
